import styled from "styled-components";



export const Container = styled.div` 
  flex: 1;
  background: ${props => props.theme.colors.white};
  padding: 20px 50px;
  min-height: calc(100dvh - 100px);
  display: flex;
  flex-direction: column;

  @media (max-width: 690px) {
    padding-inline: 30px;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  position: relative;
`

export const PhotoContainer = styled.div`
 width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #D9D9D9;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
    flex-shrink: 0;
`

export const Photo = styled.img`
  max-width: 100%;
  max-height: 100%;
`

export const ErrorMessage = styled.span`
  font-size: .857rem;
  color: ${props => props.theme.colors.halfOpacityBlack};
  align-self: center;
  margin: 20px 0 5px;
`


export const ReloadLink = styled.a`
  color: ${props => props.theme.colors.blue};
  align-self: center;
  font-size: .857rem;

  :hover{
    cursor: pointer;
  }
`